import { Section } from '../types';
import React from 'react';
import { getSectionElement } from './tools';

type ElementProps = {
  section: Section;
};
function SectionElement({ section }: ElementProps) {
  const { title } = section;
  const Element = getSectionElement(section);

  return (
    <>
      {title && (
        <div className="flex items-center gap-2">
          <h1 className="font-bold text-2xl my-0 flex-grow">{title}</h1>
        </div>
      )}
      <Element section={section} />
    </>
  );
}

export { SectionElement };
